import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { PermissionTemplateEntity } from '../entities/MembershipEntity.js';

interface Deps { membershipRepository: IMembershipRepository; }
export function createImportPermissionTemplateUseCase({ membershipRepository }: Deps) {
  return async function importPermissionTemplate(orgId: string, template: PermissionTemplateEntity): Promise<void> {
    return membershipRepository.importPermissionTemplate(orgId, template);
  };
}
